import PageDictionaries from './PageDictionaries';



export default PageDictionaries;
